import ProvideFeedbackPage from './provide-feedback-page'

export default ProvideFeedbackPage